"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useControlledState = useControlledState;
var _react = require("react");
var _warning = _interopRequireDefault(require("warning"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * SPDX-FileCopyrightText: © 2021 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function useControlledState(_ref) {
  var defaultName = _ref.defaultName,
    defaultValue = _ref.defaultValue,
    handleName = _ref.handleName,
    name = _ref.name,
    onChange = _ref.onChange,
    value = _ref.value;
  var _useState = (0, _react.useState)(defaultValue === undefined ? value : defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    stateValue = _useState2[0],
    setStateValue = _useState2[1];
  var ref = (0, _react.useRef)(value !== undefined);
  var wasControlled = ref.current;
  var isControlled = value !== undefined;
  if (wasControlled !== isControlled) {
    console.warn("WARN: A component changed from ".concat(wasControlled ? 'controlled' : 'uncontrolled', " to ").concat(isControlled ? 'controlled' : 'uncontrolled', ". This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled '").concat(name, "' prop for the lifetime of the component."));
  }
  ref.current = isControlled;
  "production" !== "production" ? (0, _warning.default)(!(typeof onChange === 'undefined' && typeof value !== 'undefined'), "You provided a '".concat(name, "' prop for a component without a handler '").concat(handleName, "'. This will render the component with an internal state, if the component is to be uncontrolled, use '").concat(defaultName, "'. Otherwise, set the '").concat(handleName, "' handler.")) : void 0;
  var setValue = (0, _react.useCallback)(function (value) {
    if (!isControlled) {
      setStateValue(value);
    }
    if (onChange) {
      onChange(value);
    }
  }, [isControlled, onChange]);
  if (!isControlled) {
    value = stateValue;
  }
  return [value, setValue, !isControlled];
}